var map = {
	"./ActivityLevel.png": "./src/assets/image/ActivityLevel.png",
	"./BodyType.png": "./src/assets/image/BodyType.png",
	"./FitnessLevel.png": "./src/assets/image/FitnessLevel.png",
	"./START.png": "./src/assets/image/START.png",
	"./Stripe.png": "./src/assets/image/Stripe.png",
	"./Vector_left.png": "./src/assets/image/Vector_left.png",
	"./Vector_right.png": "./src/assets/image/Vector_right.png",
	"./WorkoutLevel.png": "./src/assets/image/WorkoutLevel.png",
	"./YogaLevel.png": "./src/assets/image/YogaLevel.png",
	"./about1.png": "./src/assets/image/about1.png",
	"./about2.png": "./src/assets/image/about2.png",
	"./about3.png": "./src/assets/image/about3.png",
	"./about_icon1.png": "./src/assets/image/about_icon1.png",
	"./about_icon2.png": "./src/assets/image/about_icon2.png",
	"./about_icon3.png": "./src/assets/image/about_icon3.png",
	"./apple_logo.png": "./src/assets/image/apple_logo.png",
	"./ar/code1.png": "./src/assets/image/ar/code1.png",
	"./ar/code2.png": "./src/assets/image/ar/code2.png",
	"./ar/frame.png": "./src/assets/image/ar/frame.png",
	"./ar/frame_2.png": "./src/assets/image/ar/frame_2.png",
	"./ar/img_about_us_photo1.png": "./src/assets/image/ar/img_about_us_photo1.png",
	"./ar/img_about_us_photo2.png": "./src/assets/image/ar/img_about_us_photo2.png",
	"./ar/img_reviews_top.png": "./src/assets/image/ar/img_reviews_top.png",
	"./ar/know_chart.png": "./src/assets/image/ar/know_chart.png",
	"./ar/logo.png": "./src/assets/image/ar/logo.png",
	"./ar/logo_home.png": "./src/assets/image/ar/logo_home.png",
	"./ar/logo_other.png": "./src/assets/image/ar/logo_other.png",
	"./ar/visa.png": "./src/assets/image/ar/visa.png",
	"./ask1.png": "./src/assets/image/ask1.png",
	"./ask2.png": "./src/assets/image/ask2.png",
	"./ask3.png": "./src/assets/image/ask3.png",
	"./avatar_1.png": "./src/assets/image/avatar_1.png",
	"./avatar_2.png": "./src/assets/image/avatar_2.png",
	"./avatar_3.png": "./src/assets/image/avatar_3.png",
	"./base_code.png": "./src/assets/image/base_code.png",
	"./bmi01.png": "./src/assets/image/bmi01.png",
	"./bmi02.png": "./src/assets/image/bmi02.png",
	"./bmi03.png": "./src/assets/image/bmi03.png",
	"./chairYogaPlans.png": "./src/assets/image/chairYogaPlans.png",
	"./chairYogaPlans1.png": "./src/assets/image/chairYogaPlans1.png",
	"./chairYogaPlans2.png": "./src/assets/image/chairYogaPlans2.png",
	"./chairYogaPlans3.png": "./src/assets/image/chairYogaPlans3.png",
	"./chart_bg.png": "./src/assets/image/chart_bg.png",
	"./circle_icon.png": "./src/assets/image/circle_icon.png",
	"./clock-o.png": "./src/assets/image/clock-o.png",
	"./code.png": "./src/assets/image/code.png",
	"./credit-card-check.png": "./src/assets/image/credit-card-check.png",
	"./de/code.png": "./src/assets/image/de/code.png",
	"./de/code1.png": "./src/assets/image/de/code1.png",
	"./de/code2.png": "./src/assets/image/de/code2.png",
	"./de/frame.png": "./src/assets/image/de/frame.png",
	"./de/img_about_us_photo1.png": "./src/assets/image/de/img_about_us_photo1.png",
	"./de/img_about_us_photo2.png": "./src/assets/image/de/img_about_us_photo2.png",
	"./de/img_reviews_top.png": "./src/assets/image/de/img_reviews_top.png",
	"./de/know_chart.png": "./src/assets/image/de/know_chart.png",
	"./de/logo.png": "./src/assets/image/de/logo.png",
	"./de/logo_home.png": "./src/assets/image/de/logo_home.png",
	"./de/logo_other.png": "./src/assets/image/de/logo_other.png",
	"./de/visa.png": "./src/assets/image/de/visa.png",
	"./de/w.png": "./src/assets/image/de/w.png",
	"./en/code.png": "./src/assets/image/en/code.png",
	"./en/code1.png": "./src/assets/image/en/code1.png",
	"./en/code2.png": "./src/assets/image/en/code2.png",
	"./en/frame.png": "./src/assets/image/en/frame.png",
	"./en/frame_2.png": "./src/assets/image/en/frame_2.png",
	"./en/img_about_us_photo1.png": "./src/assets/image/en/img_about_us_photo1.png",
	"./en/img_about_us_photo2.png": "./src/assets/image/en/img_about_us_photo2.png",
	"./en/img_reviews_top.png": "./src/assets/image/en/img_reviews_top.png",
	"./en/know_chart.png": "./src/assets/image/en/know_chart.png",
	"./en/logo.png": "./src/assets/image/en/logo.png",
	"./en/logo_home.png": "./src/assets/image/en/logo_home.png",
	"./en/logo_other.png": "./src/assets/image/en/logo_other.png",
	"./en/paywall_swiper.png": "./src/assets/image/en/paywall_swiper.png",
	"./en/paywall_swiper1.png": "./src/assets/image/en/paywall_swiper1.png",
	"./en/paywall_swiper2.png": "./src/assets/image/en/paywall_swiper2.png",
	"./en/paywall_swiper3.png": "./src/assets/image/en/paywall_swiper3.png",
	"./en/plan_date.png": "./src/assets/image/en/plan_date.png",
	"./en/visa.png": "./src/assets/image/en/visa.png",
	"./es/code.png": "./src/assets/image/es/code.png",
	"./es/code1.png": "./src/assets/image/es/code1.png",
	"./es/code2.png": "./src/assets/image/es/code2.png",
	"./es/frame.png": "./src/assets/image/es/frame.png",
	"./es/img_about_us_photo1.png": "./src/assets/image/es/img_about_us_photo1.png",
	"./es/img_about_us_photo2.png": "./src/assets/image/es/img_about_us_photo2.png",
	"./es/img_reviews_top.png": "./src/assets/image/es/img_reviews_top.png",
	"./es/know_chart.png": "./src/assets/image/es/know_chart.png",
	"./es/logo.png": "./src/assets/image/es/logo.png",
	"./es/logo_home.png": "./src/assets/image/es/logo_home.png",
	"./es/logo_other.png": "./src/assets/image/es/logo_other.png",
	"./es/visa.png": "./src/assets/image/es/visa.png",
	"./es/w.png": "./src/assets/image/es/w.png",
	"./flag.png": "./src/assets/image/flag.png",
	"./flat.png": "./src/assets/image/flat.png",
	"./fr/code.png": "./src/assets/image/fr/code.png",
	"./fr/code1.png": "./src/assets/image/fr/code1.png",
	"./fr/code2.png": "./src/assets/image/fr/code2.png",
	"./fr/frame.png": "./src/assets/image/fr/frame.png",
	"./fr/img_about_us_photo1.png": "./src/assets/image/fr/img_about_us_photo1.png",
	"./fr/img_about_us_photo2.png": "./src/assets/image/fr/img_about_us_photo2.png",
	"./fr/img_reviews_top.png": "./src/assets/image/fr/img_reviews_top.png",
	"./fr/know_chart.png": "./src/assets/image/fr/know_chart.png",
	"./fr/logo.png": "./src/assets/image/fr/logo.png",
	"./fr/logo_home.png": "./src/assets/image/fr/logo_home.png",
	"./fr/logo_other.png": "./src/assets/image/fr/logo_other.png",
	"./fr/visa.png": "./src/assets/image/fr/visa.png",
	"./fr/w.png": "./src/assets/image/fr/w.png",
	"./frame.png": "./src/assets/image/frame.png",
	"./gift.png": "./src/assets/image/gift.png",
	"./hand.png": "./src/assets/image/hand.png",
	"./health.png": "./src/assets/image/health.png",
	"./home_loginout.png": "./src/assets/image/home_loginout.png",
	"./icon.png": "./src/assets/image/icon.png",
	"./icon_0.png": "./src/assets/image/icon_0.png",
	"./icon_1.png": "./src/assets/image/icon_1.png",
	"./icon_2.png": "./src/assets/image/icon_2.png",
	"./icon_3.png": "./src/assets/image/icon_3.png",
	"./icon_4.png": "./src/assets/image/icon_4.png",
	"./icon_target.png": "./src/assets/image/icon_target.png",
	"./icon_weight.png": "./src/assets/image/icon_weight.png",
	"./img_paywall_result1.png": "./src/assets/image/img_paywall_result1.png",
	"./img_paywall_result2.png": "./src/assets/image/img_paywall_result2.png",
	"./img_paywall_result3.png": "./src/assets/image/img_paywall_result3.png",
	"./includes1.png": "./src/assets/image/includes1.png",
	"./includes2.png": "./src/assets/image/includes2.png",
	"./includes3.png": "./src/assets/image/includes3.png",
	"./includes4.png": "./src/assets/image/includes4.png",
	"./includes5.png": "./src/assets/image/includes5.png",
	"./includes6.png": "./src/assets/image/includes6.png",
	"./includes7.png": "./src/assets/image/includes7.png",
	"./includes8.png": "./src/assets/image/includes8.png",
	"./it/code.png": "./src/assets/image/it/code.png",
	"./it/code1.png": "./src/assets/image/it/code1.png",
	"./it/code2.png": "./src/assets/image/it/code2.png",
	"./it/frame.png": "./src/assets/image/it/frame.png",
	"./it/img_about_us_photo1.png": "./src/assets/image/it/img_about_us_photo1.png",
	"./it/img_about_us_photo2.png": "./src/assets/image/it/img_about_us_photo2.png",
	"./it/img_reviews_top.png": "./src/assets/image/it/img_reviews_top.png",
	"./it/know_chart.png": "./src/assets/image/it/know_chart.png",
	"./it/logo.png": "./src/assets/image/it/logo.png",
	"./it/logo_home.png": "./src/assets/image/it/logo_home.png",
	"./it/logo_other.png": "./src/assets/image/it/logo_other.png",
	"./it/visa.png": "./src/assets/image/it/visa.png",
	"./it/w.png": "./src/assets/image/it/w.png",
	"./ja/code.png": "./src/assets/image/ja/code.png",
	"./ja/code1.png": "./src/assets/image/ja/code1.png",
	"./ja/code2.png": "./src/assets/image/ja/code2.png",
	"./ja/frame.png": "./src/assets/image/ja/frame.png",
	"./ja/img_about_us_photo1.png": "./src/assets/image/ja/img_about_us_photo1.png",
	"./ja/img_about_us_photo2.png": "./src/assets/image/ja/img_about_us_photo2.png",
	"./ja/img_reviews_top.png": "./src/assets/image/ja/img_reviews_top.png",
	"./ja/know_chart.png": "./src/assets/image/ja/know_chart.png",
	"./ja/logo.png": "./src/assets/image/ja/logo.png",
	"./ja/logo_home.png": "./src/assets/image/ja/logo_home.png",
	"./ja/logo_other.png": "./src/assets/image/ja/logo_other.png",
	"./ja/visa.png": "./src/assets/image/ja/visa.png",
	"./ja/w.png": "./src/assets/image/ja/w.png",
	"./lock.png": "./src/assets/image/lock.png",
	"./logo.png": "./src/assets/image/logo.png",
	"./logout.png": "./src/assets/image/logout.png",
	"./other_loginout.png": "./src/assets/image/other_loginout.png",
	"./payment_logo.png": "./src/assets/image/payment_logo.png",
	"./payment_logo_active.png": "./src/assets/image/payment_logo_active.png",
	"./paypal.png": "./src/assets/image/paypal.png",
	"./paywall_swiper.png": "./src/assets/image/paywall_swiper.png",
	"./paywall_swiper1.png": "./src/assets/image/paywall_swiper1.png",
	"./paywall_swiper2.png": "./src/assets/image/paywall_swiper2.png",
	"./paywall_swiper3.png": "./src/assets/image/paywall_swiper3.png",
	"./plan1.png": "./src/assets/image/plan1.png",
	"./plan2.png": "./src/assets/image/plan2.png",
	"./plan3.png": "./src/assets/image/plan3.png",
	"./plan4.png": "./src/assets/image/plan4.png",
	"./plan_date.png": "./src/assets/image/plan_date.png",
	"./plan_preview1_1.png": "./src/assets/image/plan_preview1_1.png",
	"./plan_preview1_2.png": "./src/assets/image/plan_preview1_2.png",
	"./plan_preview1_3.png": "./src/assets/image/plan_preview1_3.png",
	"./plan_preview1_4.png": "./src/assets/image/plan_preview1_4.png",
	"./plan_preview2_1.png": "./src/assets/image/plan_preview2_1.png",
	"./plan_preview2_2.png": "./src/assets/image/plan_preview2_2.png",
	"./plan_preview2_3.png": "./src/assets/image/plan_preview2_3.png",
	"./plan_preview2_4.png": "./src/assets/image/plan_preview2_4.png",
	"./plan_preview3_1.png": "./src/assets/image/plan_preview3_1.png",
	"./plan_preview3_2.png": "./src/assets/image/plan_preview3_2.png",
	"./plan_preview3_3.png": "./src/assets/image/plan_preview3_3.png",
	"./plan_preview3_4.png": "./src/assets/image/plan_preview3_4.png",
	"./premium_icon.png": "./src/assets/image/premium_icon.png",
	"./price_bg.png": "./src/assets/image/price_bg.png",
	"./price_bg_reverse.png": "./src/assets/image/price_bg_reverse.png",
	"./ruler.png": "./src/assets/image/ruler.png",
	"./stripe.png": "./src/assets/image/stripe.png",
	"./target1.png": "./src/assets/image/target1.png",
	"./target2.png": "./src/assets/image/target2.png",
	"./target3.png": "./src/assets/image/target3.png",
	"./target4.png": "./src/assets/image/target4.png",
	"./target5.png": "./src/assets/image/target5.png",
	"./target6.png": "./src/assets/image/target6.png",
	"./target7.png": "./src/assets/image/target7.png",
	"./template/achieve-image-01.png": "./src/assets/image/template/achieve-image-01.png",
	"./template/achieve-image-02.png": "./src/assets/image/template/achieve-image-02.png",
	"./template/achieve-image-03.png": "./src/assets/image/template/achieve-image-03.png",
	"./template/achieve-image-04.png": "./src/assets/image/template/achieve-image-04.png",
	"./template/achieve-image-05.png": "./src/assets/image/template/achieve-image-05.png",
	"./template/achieve-image-06.png": "./src/assets/image/template/achieve-image-06.png",
	"./template/achieve-image-1.png": "./src/assets/image/template/achieve-image-1.png",
	"./template/achieve-image-2.png": "./src/assets/image/template/achieve-image-2.png",
	"./template/achieve-image-3.png": "./src/assets/image/template/achieve-image-3.png",
	"./template/achieve-image-4.png": "./src/assets/image/template/achieve-image-4.png",
	"./template/achieve-image-5.png": "./src/assets/image/template/achieve-image-5.png",
	"./template/achieve-image-6.png": "./src/assets/image/template/achieve-image-6.png",
	"./template/achieve-image-7.png": "./src/assets/image/template/achieve-image-7.png",
	"./template/achieve1-image-2.png": "./src/assets/image/template/achieve1-image-2.png",
	"./template/activityLevel-image-1.png": "./src/assets/image/template/activityLevel-image-1.png",
	"./template/activityLevel-image-2.png": "./src/assets/image/template/activityLevel-image-2.png",
	"./template/activityLevel-image-3.png": "./src/assets/image/template/activityLevel-image-3.png",
	"./template/activityLevel-image-4.png": "./src/assets/image/template/activityLevel-image-4.png",
	"./template/activityLevel-image-5.png": "./src/assets/image/template/activityLevel-image-5.png",
	"./template/age-image-1.png": "./src/assets/image/template/age-image-1.png",
	"./template/age-image-2.png": "./src/assets/image/template/age-image-2.png",
	"./template/age-image-3.png": "./src/assets/image/template/age-image-3.png",
	"./template/age-image-4.png": "./src/assets/image/template/age-image-4.png",
	"./template/boarding_achievement6.png": "./src/assets/image/template/boarding_achievement6.png",
	"./template/boarding_activity_level.png": "./src/assets/image/template/boarding_activity_level.png",
	"./template/boarding_body_type.png": "./src/assets/image/template/boarding_body_type.png",
	"./template/boarding_calculating_your_bmi.png": "./src/assets/image/template/boarding_calculating_your_bmi.png",
	"./template/boarding_calendar.png": "./src/assets/image/template/boarding_calendar.png",
	"./template/boarding_drag_round.png": "./src/assets/image/template/boarding_drag_round.png",
	"./template/boarding_emoji_age.png": "./src/assets/image/template/boarding_emoji_age.png",
	"./template/boarding_emoji_danger.png": "./src/assets/image/template/boarding_emoji_danger.png",
	"./template/boarding_emoji_green_heart.png": "./src/assets/image/template/boarding_emoji_green_heart.png",
	"./template/boarding_emoji_ok.png": "./src/assets/image/template/boarding_emoji_ok.png",
	"./template/boarding_emoji_strength.png": "./src/assets/image/template/boarding_emoji_strength.png",
	"./template/boarding_emoji_trophy.png": "./src/assets/image/template/boarding_emoji_trophy.png",
	"./template/boarding_emoji_warning.png": "./src/assets/image/template/boarding_emoji_warning.png",
	"./template/boarding_intro_item.png": "./src/assets/image/template/boarding_intro_item.png",
	"./template/boarding_normal.png": "./src/assets/image/template/boarding_normal.png",
	"./template/boarding_obese.png": "./src/assets/image/template/boarding_obese.png",
	"./template/boarding_overweight.png": "./src/assets/image/template/boarding_overweight.png",
	"./template/boarding_sanjiao.png": "./src/assets/image/template/boarding_sanjiao.png",
	"./template/boarding_select.png": "./src/assets/image/template/boarding_select.png",
	"./template/boarding_selected.png": "./src/assets/image/template/boarding_selected.png",
	"./template/boarding_underweight.png": "./src/assets/image/template/boarding_underweight.png",
	"./template/boarding_yoga_level.png": "./src/assets/image/template/boarding_yoga_level.png",
	"./template/boarding_yoga_level1.png": "./src/assets/image/template/boarding_yoga_level1.png",
	"./template/boarding_yoga_level2.png": "./src/assets/image/template/boarding_yoga_level2.png",
	"./template/boarding_yoga_level3.png": "./src/assets/image/template/boarding_yoga_level3.png",
	"./template/boarding_yoga_level4.png": "./src/assets/image/template/boarding_yoga_level4.png",
	"./template/body_fat1.png": "./src/assets/image/template/body_fat1.png",
	"./template/body_fat2.png": "./src/assets/image/template/body_fat2.png",
	"./template/bodypart-image.png": "./src/assets/image/template/bodypart-image.png",
	"./template/bodytype-image-1.png": "./src/assets/image/template/bodytype-image-1.png",
	"./template/bodytype-image-2.png": "./src/assets/image/template/bodytype-image-2.png",
	"./template/bodytype-image-3.png": "./src/assets/image/template/bodytype-image-3.png",
	"./template/breathCondition-image-1.png": "./src/assets/image/template/breathCondition-image-1.png",
	"./template/breathCondition-image-2.png": "./src/assets/image/template/breathCondition-image-2.png",
	"./template/breathCondition-image-3.png": "./src/assets/image/template/breathCondition-image-3.png",
	"./template/breathCondition-image-4.png": "./src/assets/image/template/breathCondition-image-4.png",
	"./template/code.png": "./src/assets/image/template/code.png",
	"./template/dietScreen-image-1.png": "./src/assets/image/template/dietScreen-image-1.png",
	"./template/dietScreen-image-2.png": "./src/assets/image/template/dietScreen-image-2.png",
	"./template/dietScreen-image-3.png": "./src/assets/image/template/dietScreen-image-3.png",
	"./template/dietScreen-image-4.png": "./src/assets/image/template/dietScreen-image-4.png",
	"./template/dietScreen-image-5.png": "./src/assets/image/template/dietScreen-image-5.png",
	"./template/dream-bodytype-image-1.png": "./src/assets/image/template/dream-bodytype-image-1.png",
	"./template/dream-bodytype-image-2.png": "./src/assets/image/template/dream-bodytype-image-2.png",
	"./template/dream-bodytype-image-3.png": "./src/assets/image/template/dream-bodytype-image-3.png",
	"./template/energyLevel-image-1.png": "./src/assets/image/template/energyLevel-image-1.png",
	"./template/energyLevel-image-2.png": "./src/assets/image/template/energyLevel-image-2.png",
	"./template/energyLevel-image-3.png": "./src/assets/image/template/energyLevel-image-3.png",
	"./template/energyLevel-image-4.png": "./src/assets/image/template/energyLevel-image-4.png",
	"./template/eventScreen-image-1.png": "./src/assets/image/template/eventScreen-image-1.png",
	"./template/eventScreen-image-2.png": "./src/assets/image/template/eventScreen-image-2.png",
	"./template/eventScreen-image-3.png": "./src/assets/image/template/eventScreen-image-3.png",
	"./template/eventScreen-image-4.png": "./src/assets/image/template/eventScreen-image-4.png",
	"./template/eventScreen-image-5.png": "./src/assets/image/template/eventScreen-image-5.png",
	"./template/eventScreen-image-6.png": "./src/assets/image/template/eventScreen-image-6.png",
	"./template/eventScreen-image-7.png": "./src/assets/image/template/eventScreen-image-7.png",
	"./template/eventScreen-image-8.png": "./src/assets/image/template/eventScreen-image-8.png",
	"./template/familiarity-image-1.png": "./src/assets/image/template/familiarity-image-1.png",
	"./template/familiarity-image-2.png": "./src/assets/image/template/familiarity-image-2.png",
	"./template/familiarity-image-3.png": "./src/assets/image/template/familiarity-image-3.png",
	"./template/flexibilty-image-1.png": "./src/assets/image/template/flexibilty-image-1.png",
	"./template/flexibilty-image-2.png": "./src/assets/image/template/flexibilty-image-2.png",
	"./template/flexibilty-image-3.png": "./src/assets/image/template/flexibilty-image-3.png",
	"./template/generationScreen-image.png": "./src/assets/image/template/generationScreen-image.png",
	"./template/happybody-image-1.png": "./src/assets/image/template/happybody-image-1.png",
	"./template/happybody-image-2.png": "./src/assets/image/template/happybody-image-2.png",
	"./template/happybody-image-3.png": "./src/assets/image/template/happybody-image-3.png",
	"./template/happybody-image-4.png": "./src/assets/image/template/happybody-image-4.png",
	"./template/happybody-image-5.png": "./src/assets/image/template/happybody-image-5.png",
	"./template/icon_star_light.png": "./src/assets/image/template/icon_star_light.png",
	"./template/img_age_right.png": "./src/assets/image/template/img_age_right.png",
	"./template/img_app1.png": "./src/assets/image/template/img_app1.png",
	"./template/img_app2.png": "./src/assets/image/template/img_app2.png",
	"./template/img_app3.png": "./src/assets/image/template/img_app3.png",
	"./template/img_appStore.png": "./src/assets/image/template/img_appStore.png",
	"./template/img_app_details_left.png": "./src/assets/image/template/img_app_details_left.png",
	"./template/img_app_details_right.png": "./src/assets/image/template/img_app_details_right.png",
	"./template/img_apple.png": "./src/assets/image/template/img_apple.png",
	"./template/img_back_black.png": "./src/assets/image/template/img_back_black.png",
	"./template/img_back_ob.png": "./src/assets/image/template/img_back_ob.png",
	"./template/img_back_ob2.png": "./src/assets/image/template/img_back_ob2.png",
	"./template/img_brand_mastercard.png": "./src/assets/image/template/img_brand_mastercard.png",
	"./template/img_brand_stripe.png": "./src/assets/image/template/img_brand_stripe.png",
	"./template/img_brand_visa.png": "./src/assets/image/template/img_brand_visa.png",
	"./template/img_chart_down.png": "./src/assets/image/template/img_chart_down.png",
	"./template/img_chart_fair.png": "./src/assets/image/template/img_chart_fair.png",
	"./template/img_chart_up.png": "./src/assets/image/template/img_chart_up.png",
	"./template/img_customized_programs.png": "./src/assets/image/template/img_customized_programs.png",
	"./template/img_email.png": "./src/assets/image/template/img_email.png",
	"./template/img_email_lock.png": "./src/assets/image/template/img_email_lock.png",
	"./template/img_email_star.png": "./src/assets/image/template/img_email_star.png",
	"./template/img_emoji1.png": "./src/assets/image/template/img_emoji1.png",
	"./template/img_emoji2.png": "./src/assets/image/template/img_emoji2.png",
	"./template/img_emoji3.png": "./src/assets/image/template/img_emoji3.png",
	"./template/img_fascinating_features.png": "./src/assets/image/template/img_fascinating_features.png",
	"./template/img_hint1.png": "./src/assets/image/template/img_hint1.png",
	"./template/img_hint2.png": "./src/assets/image/template/img_hint2.png",
	"./template/img_hint_phone.png": "./src/assets/image/template/img_hint_phone.png",
	"./template/img_homepage_right.png": "./src/assets/image/template/img_homepage_right.png",
	"./template/img_homepage_right_black.png": "./src/assets/image/template/img_homepage_right_black.png",
	"./template/img_honor1.png": "./src/assets/image/template/img_honor1.png",
	"./template/img_honor2.png": "./src/assets/image/template/img_honor2.png",
	"./template/img_item_left.png": "./src/assets/image/template/img_item_left.png",
	"./template/img_item_right.png": "./src/assets/image/template/img_item_right.png",
	"./template/img_loading.png": "./src/assets/image/template/img_loading.png",
	"./template/img_log_out.png": "./src/assets/image/template/img_log_out.png",
	"./template/img_menu.png": "./src/assets/image/template/img_menu.png",
	"./template/img_menu_back.png": "./src/assets/image/template/img_menu_back.png",
	"./template/img_menu_black.png": "./src/assets/image/template/img_menu_black.png",
	"./template/img_menu_close.png": "./src/assets/image/template/img_menu_close.png",
	"./template/img_ob_title_logo.png": "./src/assets/image/template/img_ob_title_logo.png",
	"./template/img_pay_success.png": "./src/assets/image/template/img_pay_success.png",
	"./template/img_payment_gift.png": "./src/assets/image/template/img_payment_gift.png",
	"./template/img_payment_intercept.png": "./src/assets/image/template/img_payment_intercept.png",
	"./template/img_paywall_badge.png": "./src/assets/image/template/img_paywall_badge.png",
	"./template/img_paywall_focus_areas_select.png": "./src/assets/image/template/img_paywall_focus_areas_select.png",
	"./template/img_paywall_plan1.png": "./src/assets/image/template/img_paywall_plan1.png",
	"./template/img_paywall_plan2.png": "./src/assets/image/template/img_paywall_plan2.png",
	"./template/img_paywall_plan3.png": "./src/assets/image/template/img_paywall_plan3.png",
	"./template/img_paywall_plan4.png": "./src/assets/image/template/img_paywall_plan4.png",
	"./template/img_paywall_qa1.png": "./src/assets/image/template/img_paywall_qa1.png",
	"./template/img_paywall_qa2.png": "./src/assets/image/template/img_paywall_qa2.png",
	"./template/img_paywall_qa3.png": "./src/assets/image/template/img_paywall_qa3.png",
	"./template/img_paywall_select.png": "./src/assets/image/template/img_paywall_select.png",
	"./template/img_paywall_selected.png": "./src/assets/image/template/img_paywall_selected.png",
	"./template/img_paywall_star.png": "./src/assets/image/template/img_paywall_star.png",
	"./template/img_paywall_stared.png": "./src/assets/image/template/img_paywall_stared.png",
	"./template/img_paywall_target.png": "./src/assets/image/template/img_paywall_target.png",
	"./template/img_paywall_time.png": "./src/assets/image/template/img_paywall_time.png",
	"./template/img_paywall_weight.png": "./src/assets/image/template/img_paywall_weight.png",
	"./template/img_plan_calendar.png": "./src/assets/image/template/img_plan_calendar.png",
	"./template/img_policy_back.png": "./src/assets/image/template/img_policy_back.png",
	"./template/img_product_money_bg.png": "./src/assets/image/template/img_product_money_bg.png",
	"./template/img_professional_coaches.png": "./src/assets/image/template/img_professional_coaches.png",
	"./template/img_pwd_close.png": "./src/assets/image/template/img_pwd_close.png",
	"./template/img_pwd_open.png": "./src/assets/image/template/img_pwd_open.png",
	"./template/img_reviews_top.png": "./src/assets/image/template/img_reviews_top.png",
	"./template/img_safety.png": "./src/assets/image/template/img_safety.png",
	"./template/img_star.png": "./src/assets/image/template/img_star.png",
	"./template/img_stripe.png": "./src/assets/image/template/img_stripe.png",
	"./template/img_tailored_workouts.png": "./src/assets/image/template/img_tailored_workouts.png",
	"./template/img_user1.png": "./src/assets/image/template/img_user1.png",
	"./template/img_user2.png": "./src/assets/image/template/img_user2.png",
	"./template/img_user3.png": "./src/assets/image/template/img_user3.png",
	"./template/img_video_first.png": "./src/assets/image/template/img_video_first.png",
	"./template/intro-image-1-cy.png": "./src/assets/image/template/intro-image-1-cy.png",
	"./template/intro-image-1.png": "./src/assets/image/template/intro-image-1.png",
	"./template/intro-image-2.png": "./src/assets/image/template/intro-image-2.png",
	"./template/intro-image-3.png": "./src/assets/image/template/intro-image-3.png",
	"./template/intro-image-4.png": "./src/assets/image/template/intro-image-4.png",
	"./template/intro-image-5.png": "./src/assets/image/template/intro-image-5.png",
	"./template/intro-image-6.png": "./src/assets/image/template/intro-image-6.png",
	"./template/normal.png": "./src/assets/image/template/normal.png",
	"./template/normal1.png": "./src/assets/image/template/normal1.png",
	"./template/normal2.png": "./src/assets/image/template/normal2.png",
	"./template/obese.png": "./src/assets/image/template/obese.png",
	"./template/obese1.png": "./src/assets/image/template/obese1.png",
	"./template/obese2.png": "./src/assets/image/template/obese2.png",
	"./template/overweight.png": "./src/assets/image/template/overweight.png",
	"./template/overweight1.png": "./src/assets/image/template/overweight1.png",
	"./template/overweight2.png": "./src/assets/image/template/overweight2.png",
	"./template/paywall_body_type1.png": "./src/assets/image/template/paywall_body_type1.png",
	"./template/paywall_body_type2.png": "./src/assets/image/template/paywall_body_type2.png",
	"./template/paywall_body_type3.png": "./src/assets/image/template/paywall_body_type3.png",
	"./template/paywall_body_type4.png": "./src/assets/image/template/paywall_body_type4.png",
	"./template/paywall_dream_body_type1.png": "./src/assets/image/template/paywall_dream_body_type1.png",
	"./template/paywall_dream_body_type2.png": "./src/assets/image/template/paywall_dream_body_type2.png",
	"./template/paywall_dream_body_type3.png": "./src/assets/image/template/paywall_dream_body_type3.png",
	"./template/paywall_dream_body_type4.png": "./src/assets/image/template/paywall_dream_body_type4.png",
	"./template/preferredPosition-image-1.png": "./src/assets/image/template/preferredPosition-image-1.png",
	"./template/preferredPosition-image-2.png": "./src/assets/image/template/preferredPosition-image-2.png",
	"./template/preferredPosition-image-3.png": "./src/assets/image/template/preferredPosition-image-3.png",
	"./template/purpost-image-1.png": "./src/assets/image/template/purpost-image-1.png",
	"./template/purpost-image-2.png": "./src/assets/image/template/purpost-image-2.png",
	"./template/restriction-image-1.png": "./src/assets/image/template/restriction-image-1.png",
	"./template/restriction-image-2.png": "./src/assets/image/template/restriction-image-2.png",
	"./template/restriction-image-3.png": "./src/assets/image/template/restriction-image-3.png",
	"./template/restriction-image-3.png.png": "./src/assets/image/template/restriction-image-3.png.png",
	"./template/restriction-image-4.png": "./src/assets/image/template/restriction-image-4.png",
	"./template/restriction-image-5.png": "./src/assets/image/template/restriction-image-5.png",
	"./template/restriction-image-6.png": "./src/assets/image/template/restriction-image-6.png",
	"./template/restriction-image-7.png": "./src/assets/image/template/restriction-image-7.png",
	"./template/sleepHourScreen-image.png": "./src/assets/image/template/sleepHourScreen-image.png",
	"./template/summary-image-1.png": "./src/assets/image/template/summary-image-1.png",
	"./template/summary-image-2.png": "./src/assets/image/template/summary-image-2.png",
	"./template/summary-image-3.png": "./src/assets/image/template/summary-image-3.png",
	"./template/summary-image-4.png": "./src/assets/image/template/summary-image-4.png",
	"./template/transition-mainimage.png": "./src/assets/image/template/transition-mainimage.png",
	"./template/underweight.png": "./src/assets/image/template/underweight.png",
	"./template/underweight1.png": "./src/assets/image/template/underweight1.png",
	"./template/underweight2.png": "./src/assets/image/template/underweight2.png",
	"./template/walkingDuration-image-1.png": "./src/assets/image/template/walkingDuration-image-1.png",
	"./template/walkingDuration-image-2.png": "./src/assets/image/template/walkingDuration-image-2.png",
	"./template/walkingDuration-image-3.png": "./src/assets/image/template/walkingDuration-image-3.png",
	"./template/waterDrinkScreen-image-1.png": "./src/assets/image/template/waterDrinkScreen-image-1.png",
	"./template/waterDrinkScreen-image-2.png": "./src/assets/image/template/waterDrinkScreen-image-2.png",
	"./template/waterDrinkScreen-image-3.png": "./src/assets/image/template/waterDrinkScreen-image-3.png",
	"./template/waterDrinkScreen-image-4.png": "./src/assets/image/template/waterDrinkScreen-image-4.png",
	"./template/weight1.png": "./src/assets/image/template/weight1.png",
	"./template/weight2.png": "./src/assets/image/template/weight2.png",
	"./template/weight3.png": "./src/assets/image/template/weight3.png",
	"./template/yogaLevel-image-1.png": "./src/assets/image/template/yogaLevel-image-1.png",
	"./template/yogaLevel-image-2.png": "./src/assets/image/template/yogaLevel-image-2.png",
	"./template/yogaLevel-image-3.png": "./src/assets/image/template/yogaLevel-image-3.png",
	"./template/yogaLevel-image-4.png": "./src/assets/image/template/yogaLevel-image-4.png",
	"./theme/btn_bg_left.png": "./src/assets/image/theme/btn_bg_left.png",
	"./theme/btn_bg_right.png": "./src/assets/image/theme/btn_bg_right.png",
	"./theme/btn_icon1.png": "./src/assets/image/theme/btn_icon1.png",
	"./theme/btn_icon2.png": "./src/assets/image/theme/btn_icon2.png",
	"./theme/code-icon1.png": "./src/assets/image/theme/code-icon1.png",
	"./theme/code-icon2.png": "./src/assets/image/theme/code-icon2.png",
	"./theme/gift.png": "./src/assets/image/theme/gift.png",
	"./theme/h5_bg.png": "./src/assets/image/theme/h5_bg.png",
	"./theme/h5_text.png": "./src/assets/image/theme/h5_text.png",
	"./theme/logo.png": "./src/assets/image/theme/logo.png",
	"./theme/pc_bg.png": "./src/assets/image/theme/pc_bg.png",
	"./theme/pc_text.png": "./src/assets/image/theme/pc_text.png",
	"./theme/people_love_img.png": "./src/assets/image/theme/people_love_img.png",
	"./theme/plan_date.png": "./src/assets/image/theme/plan_date.png",
	"./theme/price_icon1.png": "./src/assets/image/theme/price_icon1.png",
	"./theme/price_icon2.png": "./src/assets/image/theme/price_icon2.png",
	"./theme/price_icon3.png": "./src/assets/image/theme/price_icon3.png",
	"./triangle.png": "./src/assets/image/triangle.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*\\.png$";